module.exports = __webpack_public_path__ + "img/TS.51c55f09.svg";